/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Table, Input, Empty, DatePicker, message } from 'antd'
// import './index.scss'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import SubscribeProgress from '../subscribeProgress'

const { RangePicker } = DatePicker
const dateFormat = 'll'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			dateRange: [],
			isExporting: false,
			exportProgress: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { user_uid, barangay_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText, dateRange = [],
			isExporting, exportProgress
		} = this.state
		let filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		if (dateRange.length > 0) {
			const startDate = moment(dateRange[0]).format('YYYY-MM-DD')
			const endDate = moment(dateRange[1]).format('YYYY-MM-DD')
			filters = Object.assign({}, filters, {
				date_start: startDate,
				date_end: endDate
			})
		}
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<Col md={6} sm={24}>
							{
								(dateRange.length > 0) &&
								<button 
									type="button" 
									className="btn btn-outline-success btn-rounded waves-effect waves-light"
									onClick={() => {
										const { exportProjects } = this.props
										const params = {
											date_start: moment(dateRange[0]).format('YYYY-MM-DD'),
											date_end: moment(dateRange[1]).format('YYYY-MM-DD'),
											searchText: searchText
										}
										exportProjects(params)
									}}
								>
									<i className='mdi mdi-file-excel'/> Export in Excel
								</button>
							}
						</Col>
						<Col md={18} sm={24}>
							<Row style={{ textAlign: 'right' }}>
								<RangePicker
									showTime
									format={dateFormat}
									style={{ marginRight: 20, width: 400 }}
									onChange={(value) => {
										// console.log('range picker value', value)
										this.setState({ dateRange: value })
									}}
								/>
								<Input 
									style={{ width: 300 }}
									placeholder='Search Here..' 
									onChange={(e)=>{
										this.setState({ searchText: e.target.value })
									}}/>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Query 
							query={BARANGAY_PROJECTS} 
							variables={{ searchFilter: filters, barangay_uid }}
							fetchPolicy='network-only'
						>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let allProjects = _.has(data,'allProjects') ? data.allProjects.data : []
								allProjects = allProjects.map((allProject, key) => Object.assign({}, allProject, { key }))
								let _pagination = _.has(data, 'allProjects') ? data.allProjects.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [
									{
										title: 'Project',
										dataIndex: 'project_name',
										key: 'project_name',
									//width: 300
									}, {
										title: 'Description',
										dataIndex: 'project_description',
										key: 'project_description'
									}, {
										title: 'Remarks',
										dataIndex: 'remarks',
										key: 'remarks'
									}, {
										title: 'Start At',
										key: 'date_start',
										render: (record) => (
											<span>{moment(record.date_start).format('ll')}</span>
										)
									}, {
										title: 'End At',
										key: 'date_end',
										render: (record) => (
											<span>{
												moment(record.date_end).isValid() ?
													moment(record.date_end).format('ll') : '- - -'
											}</span>
										)
									}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: 'projects' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={allProjects} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Col>
			</Row>
		)
	}
}

const BARANGAY_PROJECTS = gql`
    query allProjects($barangay_uid: String, $searchFilter: SearchParams) {
		allProjects(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const EXPORT_PROJECTS = gql`
    mutation exportProjects($input: JSON) {
		exportProjects(input: $input)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_PROJECTS, {
		props({ mutate }) {
			return {
				exportProjects(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
